/* Boardsox — instant client-side collection filter (no reload), modelled on the design prototype.
   Liquid-free: every collection grid carries [data-bsx-grid] + data attributes; this script
   normalises each product's messy Shopify "Surfboard Style"/"Length" data into clean type/size
   tokens, builds the filter UI from what's actually present, and shows/hides + sorts instantly.
   For collections larger than the 50-per-page Liquid cap it pulls the full set from
   /collections/<handle>/products.json so filtering still covers every product. */
(function () {
  function boot() { document.querySelectorAll('[data-bsx-grid]').forEach(init); }

  var TYPES = [
    { k: 'shortboard', label: 'Shortboard', rx: /short/ },
    { k: 'fish', label: 'Fish & Fun', rx: /fish|fun/ },
    { k: 'mid', label: 'Mid-length', rx: /mid/ },
    { k: 'longboard', label: 'Longboard', rx: /long/ },
    { k: 'gun', label: 'Big Wave Gun', rx: /gun/ },
    { k: 'soft', label: 'Soft Top', rx: /soft/ }
  ];

  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function typeOf(s) { s = (s || '').toLowerCase(); var o = []; TYPES.forEach(function (t) { if (t.rx.test(s)) o.push(t.k); }); return o; }

  function sizeNum(s) { var a = s.split("'"); return (+a[0]) * 12 + (+(a[1] || 0)); }
  function sizesOf(s) {
    s = (s || '').toLowerCase();
    var set = {}, parts = s.split(/[\s|,;\/]+/);
    function add(f, i) { if (f >= 4 && f <= 12 && i >= 0 && i <= 11) set[f + "'" + i] = 1; }
    parts.forEach(function (p) {
      if (!p || p.indexOf('custom') >= 0) return;
      var m = p.match(/^(\d{1,2})'(\d{1,2})/); if (m) { add(+m[1], +m[2]); return; }
      m = p.match(/^(\d{1,2})'/); if (m) { add(+m[1], 0); return; }
      m = p.match(/^(\d{1,2})ft/); if (m) { add(+m[1], 0); return; }
    });
    return Object.keys(set);
  }

  function init(grid) {
    if (grid._bsxInit) return; grid._bsxInit = 1;
    var section = grid.closest('.shopify-section') || document;
    var total = parseInt(grid.getAttribute('data-total') || '0', 10);
    var handle = grid.getAttribute('data-collection') || '';
    var mount = section.querySelector('[data-bsx-filter-mount]');
    var countEl = section.querySelector('[data-bsx-count]');
    var activeEl = section.querySelector('[data-bsx-active]');
    var sortEl = section.querySelector('[data-bsx-sort]');
    var fbadge = section.querySelector('[data-bsx-fc]');
    var shopFacets = section.querySelector('[data-bsx-shopify-facets]');
    var state = { type: [], size: [], avail: [], sort: (sortEl && sortEl.value) || 'manual' };
    var boardActive = false, built = false, fetching = false;

    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('.product')); }

    function money(v) { v = parseFloat(v); if (isNaN(v)) return ''; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }

    function renderFromJson(products) {
      grid.innerHTML = '';
      var soldLabel = grid.getAttribute('data-soldout-label') || 'Arriving soon';
      var bsellLabel = grid.getAttribute('data-bsell-label') || 'Best Seller';
      var bsids = grid.getAttribute('data-bsids') || '';
      products.forEach(function (p) {
        var styl = '', lng = '';
        (p.options || []).forEach(function (o) {
          var jv = ' ' + (o.values || []).join(' ');
          if (/length/i.test(o.name)) lng += jv; else styl += jv;
        });
        styl += ' ' + (p.product_type || '') + ' ' + (p.title || '');
        var vs = p.variants || [], v0 = vs[0] || {};
        var prices = vs.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
        var min = prices.length ? Math.min.apply(null, prices) : 0, max = prices.length ? Math.max.apply(null, prices) : 0;
        var img = (p.images || [])[0], src = img ? img.src : '';
        if (src) src += (src.indexOf('?') >= 0 ? '&' : '?') + 'width=700';
        var avail = (p.variants || []).some(function (v) { return v.available; });
        var isBsell = bsids.indexOf(',' + p.id + ',') >= 0 || (p.tags || []).indexOf('Bestseller') >= 0;
        var a = document.createElement('a');
        a.className = 'product' + (avail ? '' : ' oos'); a.href = '/products/' + p.handle;
        a.setAttribute('data-style', styl.trim());
        a.setAttribute('data-lengths', lng.trim());
        a.setAttribute('data-price', isFinite(min) ? min : 0);
        a.setAttribute('data-created', p.published_at ? Math.floor(Date.parse(p.published_at) / 1000) : 0);
        var badge = !avail ? '<span class="badge">' + esc(soldLabel) + '</span>' : (isBsell ? '<span class="badge bsell">' + esc(bsellLabel) + '</span>' : '');
        a.innerHTML =
          '<div class="im">' + badge + (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '<button class="qadd" type="button" data-add data-id="' + (v0.id || '') + '">Quick add</button></div>' +
          '<div class="ty">' + esc(p.product_type || '') + '</div>' +
          '<div class="nm">' + esc(p.title) + '</div>' +
          '<div class="rt"><span class="stars">★★★★★</span></div>' +
          '<div class="pr">' + (min !== max ? 'From ' : '') + money(min) + '</div>';
        grid.appendChild(a);
      });
    }

    function ensureFull(cb) {
      var have = cards().length;
      if (!total || have >= total || !handle) { cb(); return; }
      if (fetching) return;
      fetching = true;
      fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.products && d.products.length) renderFromJson(d.products); fetching = false; cb(); })
        .catch(function () { fetching = false; cb(); });
    }

    function indexCards() {
      cards().forEach(function (c, i) {
        c._t = typeOf((c.getAttribute('data-style') || '') + ' ' + (c.getAttribute('data-tags') || ''));
        c._s = sizesOf((c.getAttribute('data-lengths') || '') + ' ' + (c.getAttribute('data-tags') || ''));
        c._p = parseFloat(c.getAttribute('data-price') || '0') || 0;
        c._a = c.classList.contains('oos') ? 'out' : 'in';
        c._c = parseFloat(c.getAttribute('data-created') || '0') || 0;
        c._i = i;
      });
    }

    function buildUI() {
      if (!mount) return;
      var list = cards(), tset = {}, sset = {};
      list.forEach(function (c) {
        c._t.forEach(function (t) { tset[t] = (tset[t] || 0) + 1; });
        c._s.forEach(function (s) { sset[s] = (sset[s] || 0) + 1; });
      });
      var presentTypes = TYPES.filter(function (t) { return tset[t.k]; });
      var presentSizes = Object.keys(sset).sort(function (a, b) { return sizeNum(a) - sizeNum(b); });
      if (!presentTypes.length && !presentSizes.length) { boardActive = false; return; }
      var html = '';
      if (presentTypes.length) {
        html += '<div class="fgroup"><button class="gh" type="button">Surfboard type <svg class="chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button><div class="gbody">';
        presentTypes.forEach(function (t) {
          html += '<label class="fopt"><input type="checkbox" data-g="type" data-v="' + t.k + '"><span class="box"><svg viewBox="0 0 24 24"><path d="M5 12.5 10 17.5 19.5 7"/></svg></span>' + t.label + ' <span class="ct">' + tset[t.k] + '</span></label>';
        });
        html += '</div></div>';
      }
      if (presentSizes.length) {
        html += '<div class="fgroup"><button class="gh" type="button">Size / Length <svg class="chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button><div class="gbody"><div class="chips">';
        presentSizes.forEach(function (s) { html += '<button class="chip" type="button" data-g="size" data-v="' + s + '">' + s + '</button>'; });
        html += '</div></div></div>';
      }
      var nIn = 0, nOut = 0;
      list.forEach(function (c) { if (c._a === 'out') nOut++; else nIn++; });
      html += '<div class="fgroup"><button class="gh" type="button">Availability <svg class="chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button><div class="gbody">';
      html += '<label class="fopt"><input type="checkbox" data-g="avail" data-v="in"><span class="box"><svg viewBox="0 0 24 24"><path d="M5 12.5 10 17.5 19.5 7"/></svg></span>In stock <span class="ct">' + nIn + '</span></label>';
      html += '<label class="fopt"><input type="checkbox" data-g="avail" data-v="out"><span class="box"><svg viewBox="0 0 24 24"><path d="M5 12.5 10 17.5 19.5 7"/></svg></span>Out of stock <span class="ct">' + nOut + '</span></label>';
      html += '</div></div>';
      mount.innerHTML = html;
      boardActive = true;
      if (shopFacets) shopFacets.style.display = 'none';
      mount.querySelectorAll('input[data-g="type"]').forEach(function (inp) {
        inp.addEventListener('change', function () { toggle('type', inp.getAttribute('data-v'), inp.checked); });
      });
      mount.querySelectorAll('input[data-g="avail"]').forEach(function (inp) {
        inp.addEventListener('change', function () { toggle('avail', inp.getAttribute('data-v'), inp.checked); });
      });
      mount.querySelectorAll('.chip[data-g="size"]').forEach(function (ch) {
        ch.addEventListener('click', function () { var on = !ch.classList.contains('on'); ch.classList.toggle('on', on); toggle('size', ch.getAttribute('data-v'), on); });
      });
    }

    function toggle(g, v, on) {
      var arr = state[g], i = arr.indexOf(v);
      if (on && i < 0) arr.push(v); else if (!on && i >= 0) arr.splice(i, 1);
      apply();
    }

    function sortList(list) {
      var s = state.sort, l = list.slice();
      if (s === 'price-ascending') l.sort(function (a, b) { return a._p - b._p; });
      else if (s === 'price-descending') l.sort(function (a, b) { return b._p - a._p; });
      else if (s === 'created-descending') l.sort(function (a, b) { return b._c - a._c; });
      else l.sort(function (a, b) { return a._i - b._i; });
      return l;
    }

    function apply() {
      var list = cards(), vis = [];
      list.forEach(function (c) {
        var ok = (state.type.length === 0 || state.type.some(function (t) { return c._t.indexOf(t) >= 0; }))
          && (state.size.length === 0 || state.size.some(function (z) { return c._s.indexOf(z) >= 0; }))
          && (state.avail.length === 0 || state.avail.indexOf(c._a) >= 0);
        c.style.display = ok ? '' : 'none';
        if (ok) vis.push(c);
      });
      sortList(vis).forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = vis.length;
      if (fbadge) fbadge.textContent = state.type.length + state.size.length + state.avail.length;
      renderActive();
      toggleEmpty(vis.length === 0);
    }

    function renderActive() {
      if (!activeEl) return;
      activeEl.innerHTML = '';
      function chip(g, v, label) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'af';
        b.innerHTML = esc(label) + ' <span aria-hidden="true">✕</span>';
        b.addEventListener('click', function () {
          var i = state[g].indexOf(v); if (i >= 0) state[g].splice(i, 1);
          if (g === 'type' || g === 'avail') { var inp = mount.querySelector('input[data-g="' + g + '"][data-v="' + v + '"]'); if (inp) inp.checked = false; }
          else { var ch = mount.querySelector('.chip[data-v="' + v + '"]'); if (ch) ch.classList.remove('on'); }
          apply();
        });
        activeEl.appendChild(b);
      }
      state.type.forEach(function (v) { var t = TYPES.filter(function (x) { return x.k === v; })[0]; chip('type', v, t ? t.label : v); });
      state.size.forEach(function (v) { chip('size', v, v); });
      state.avail.forEach(function (v) { chip('avail', v, v === 'in' ? 'In stock' : 'Out of stock'); });
    }

    function toggleEmpty(show) {
      var e = grid.querySelector('.bsx-empty');
      if (show) {
        if (!e) { e = document.createElement('div'); e.className = 'bsx-empty'; e.innerHTML = '<h3>Nothing matches those filters</h3><p>Try loosening a filter or two and you’ll find your board’s match.</p>'; grid.appendChild(e); }
        e.style.display = '';
      } else if (e) { e.style.display = 'none'; }
    }

    function bindCart() {
      grid.querySelectorAll('[data-add]').forEach(function (b) {
        if (b._bound) return; b._bound = 1;
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var id = b.getAttribute('data-id'); if (!id) return;
          var t = b.textContent; b.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
            .then(function (r) { return r.json(); })
            .then(function () { b.textContent = 'Added'; document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(function () { b.textContent = t; }, 1400); })
            .catch(function () { b.textContent = t; });
        });
      });
    }

    // accordion (works for board filter + any Shopify facet fallback groups)
    section.addEventListener('click', function (e) {
      var gh = e.target.closest ? e.target.closest('.fgroup .gh') : null;
      if (gh && section.contains(gh)) gh.parentNode.classList.toggle('collapsed');
    });
    // clear all
    var clr = section.querySelector('[data-bsx-clear]');
    if (clr) clr.addEventListener('click', function (e) {
      e.preventDefault(); state.type = []; state.size = []; state.avail = [];
      if (mount) { mount.querySelectorAll('input[data-g]').forEach(function (i) { i.checked = false; }); mount.querySelectorAll('.chip.on').forEach(function (c) { c.classList.remove('on'); }); }
      apply();
    });
    // sort: client-side when board filter active, else fall back to Shopify reload
    if (sortEl) sortEl.addEventListener('change', function () {
      if (boardActive) { state.sort = sortEl.value; apply(); }
      else { var u = new URL(location.href); u.searchParams.set('sort_by', sortEl.value); location.href = u.toString(); }
    });
    // mobile drawer
    var fb = section.querySelector('[data-bsx-filterbtn]'), drawer = section.querySelector('#filters'), done = section.querySelector('#fdone');
    if (fb && drawer) fb.addEventListener('click', function () { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; });
    if (done && drawer) done.addEventListener('click', function () { drawer.classList.remove('open'); document.body.style.overflow = ''; });

    function build() {
      if (built) return;
      ensureFull(function () {
        if (built || !cards().length) return;
        indexCards();
        buildUI();
        bindCart();
        if (boardActive) apply();
        built = true;
      });
    }
    build();
    window.addEventListener('load', build);
    document.addEventListener('shopify:section:load', build);
    setTimeout(build, 300);
    setTimeout(build, 1200);
    try { new MutationObserver(function () { if (!built) build(); }).observe(grid, { childList: true }); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
